import type { FlightData } from "../../../lib/@types";

type Props = {
  flight: FlightData;
  customerEmail?: string;
  onClose: () => void;
};

/**
 * BNPL modal (`@visaro/bnpl-react-widget`) removed temporarily — file: deps break CI without sibling SDK checkout.
 * Restore WidgetModal + SDK packages when ready.
 */
const AviationBnplPayment = ({
  flight: _flight,
  customerEmail: _customerEmail,
  onClose,
}: Props) => {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-6">
      <div className="max-w-md rounded-lg bg-white p-6 shadow-lg text-center space-y-3">
        <p className="text-gray-800 font-medium">
          Installment (BNPL) checkout is temporarily unavailable
        </p>
        <p className="text-sm text-gray-600">
          Please choose another payment method to complete your booking.
        </p>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md bg-visaro-primary-700 px-4 py-2 text-white text-sm"
        >
          Back to tickets
        </button>
      </div>
    </div>
  );
};

export default AviationBnplPayment;
